import * as React from "react";

const Bookmark = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || 16}
    height={props.size ? props.size * 1.25 : 20}
    fill="none"
    {...props}
  >
    <path
      fill={props.color || "#B8B8BC"}
      fillRule="evenodd"
      d="M0 3a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v16a1 1 0 0 1-1.447.894L8 16.618l-6.553 3.276A1 1 0 0 1 0 19V3Zm3-1a1 1 0 0 0-1 1v14.382l5.553-2.776a1 1 0 0 1 .894 0L14 17.382V3a1 1 0 0 0-1-1H3Z"
      clipRule="evenodd"
    />
  </svg>
);

export default Bookmark;
